import React, { useState } from 'react';
import AppMenu from '../AppMenu/AppMenu';
import FileMenu from '../FileMenu/FileMenu';
import SettingsMenu from '../SettingsMenu/SettingsMenu';
import './SystemBar.css';
import type { LocalAuthUser } from '../../data/types';

// Props for the SystemBar component.
export interface SystemBarProps {
  currentVersion: string;
  currentUser: LocalAuthUser | null;
  darkMode: boolean;
  onToggleDarkMode: () => void;
  canSeeAppMenu: boolean;
  canDeleteScenario: boolean;
  loadedScenario: boolean;
  scenarioReadOnly?: boolean;
  onFileLoad: () => void;
  onFileNew: () => void;
  onDuplicateScenario: () => void;
  onSaveScenarioBaseState: () => void;
  onFileDelete: () => void;
  onArchiveScenario: () => void;
  onEditScenario: () => void;
  onShowArchivedScenarios: () => void;
  recentScenarioNames: string[];
  onFileLoadRecent: (name: string) => void;
  onFileReset: () => void;
  onManageProducts: () => void;
  onManageProductCategories: () => void;
  onManageUsers: () => void;
  onOpenProfile: () => void;
  onLogout: () => void;
}

const SystemBar: React.FC<SystemBarProps> = ({
  currentVersion,
  currentUser,
  darkMode,
  onToggleDarkMode,
  canSeeAppMenu,
  canDeleteScenario,
  loadedScenario,
  scenarioReadOnly = false,
  onFileLoad,
  onFileNew,
  onDuplicateScenario,
  onSaveScenarioBaseState,
  onFileDelete,
  onArchiveScenario,
  onEditScenario,
  onShowArchivedScenarios,
  recentScenarioNames,
  onFileLoadRecent,
  onFileReset,
  onManageProducts,
  onManageProductCategories,
  onManageUsers,
  onOpenProfile,
  onLogout,
}) => {
  const [openMenu, setOpenMenu] = useState<'app' | 'scenario' | 'settings' | null>(null);

  return (
    <div className="system-bar">
      {canSeeAppMenu && (
        <AppMenu
          open={openMenu === 'app'}
          onToggle={() => setOpenMenu((current) => current === 'app' ? null : 'app')}
          onClose={() => setOpenMenu(null)}
          onManageProducts={onManageProducts}
          onManageProductCategories={onManageProductCategories}
          onManageUsers={onManageUsers}
        />
      )}
      <FileMenu
        open={openMenu === 'scenario'}
        onToggle={() => setOpenMenu((current) => current === 'scenario' ? null : 'scenario')}
        onClose={() => setOpenMenu(null)}
        loadedScenario={loadedScenario}
        canDeleteScenario={canDeleteScenario}
        scenarioReadOnly={scenarioReadOnly}
        onLoad={onFileLoad}
        onNew={onFileNew}
        onDuplicateScenario={onDuplicateScenario}
        onSaveScenarioBaseState={onSaveScenarioBaseState}
        onDelete={onFileDelete}
        onArchiveScenario={onArchiveScenario}
        onEditScenario={onEditScenario}
        onShowArchivedScenarios={onShowArchivedScenarios}
        recentScenarioNames={recentScenarioNames}
        onLoadRecent={onFileLoadRecent}
        onReset={onFileReset}
      />
      <div className="system-bar-spacer"></div>
      <SettingsMenu
        open={openMenu === 'settings'}
        onToggle={() => setOpenMenu((current) => current === 'settings' ? null : 'settings')}
        onClose={() => setOpenMenu(null)}
        currentVersion={currentVersion}
        currentUser={currentUser}
        darkMode={darkMode}
        onToggleDarkMode={onToggleDarkMode}
        onOpenProfile={onOpenProfile}
        onLogout={onLogout}
      />
    </div>
  );
};

export default SystemBar;
